export default __webpack_public_path__ + "e8784478115fc3dd955285edd36ed7da.png";